import { createFlagOverridesFromMap, OverrideBehaviour, type FlagOverrides } from "configcat-react";

export const Flags = {
    OnaAIEnabled: "onaAIEnabled",
    OnaEnvironmentOnboardingEnabled: "isOnaEnvironmentOnboardingEnabled",
    InsightsDisabled: "isInsightsDisabled",

    IsGlobalHeaderEnabled: "isGlobalHeaderEnabled",
    IsGcpRunnerEnabled: "is_gcp_runner_enabled",
    AlwaysCreateFreeOnaOrgs: "always_create_free_ona_orgs",
    GlobalOverload: "global_overload",
    EnableAgentFollowMode: "enable_agent_follow_mode",
    IsSentryEnabled: "is_frontend_dash_sentry_enabled",
    WorkflowsEnabled: "workflows_enabled",
    // OnaEnabled will
    // - opt-in to the One theme for users who aren't on FREE_ONA / CORE tiers
    // - put new organizations into the FREE_ONA tier
    OnaEnabled: "ona_enabled",
    GroupManagementEnabled: "group_management_enabled",
    IsMobileVscodeEnabled: "is_mobile_vscode_enabled",
    McpEnabled: "mcp_enabled",
    UseReleasesProxy: "use_releases_proxy",
    EnvironmentAutoStartEnabled: "environment_autostart_enabled",
    GitHubAppEnabled: "github_app_enabled",
    CustomDomainEnabled: "custom_domain_enabled",
    PrebuildsEnabled: "prebuilds_enabled",
    SpecModeEnabled: "spec_mode_enabled",
    ScmToolsEnabled: "scm_tools_enabled",
    PaginatedProjectsList: "paginated_projects_list",
};

export function getLocalStorageKey(flag: string): string {
    return `feature_flag_${flag}`;
}

export function localFlagOverrides(): FlagOverrides {
    const overrides: Record<string, boolean | number> = {};

    for (const flagKey of Object.values(Flags)) {
        const storageKey = getLocalStorageKey(flagKey);
        const storedValue = localStorage.getItem(storageKey);
        if (storedValue !== null) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const parsedValue = JSON.parse(storedValue);
                if (typeof parsedValue === "boolean" || typeof parsedValue === "number") {
                    console.debug(`Local flag override from localStorage: ${flagKey} = ${parsedValue}`);
                    overrides[flagKey] = parsedValue;
                }
            } catch (e) {
                console.warn(`Failed to parse localStorage value for flag ${flagKey}`, e);
            }
        }
    }

    return createFlagOverridesFromMap(overrides, OverrideBehaviour.LocalOverRemote);
}
